<template>
    <main-confirm @confirm="$emit('closeModal')" @cancel="$emit('closeModal')" confirm-title="auth.transaction_error" description="auth.description_transaction_error" :oneOption="true">
        <icon-warning :size="60"/>
    </main-confirm>
</template>
<script>
import MainConfirm from '../../../../common/components/modals/MainConfirm.vue'
import IconWarning from '../../../../common/svg/iconWarning.vue'

export default {
    components: { MainConfirm, IconWarning },
    name: "TransactionError"
}
</script>